import { useIntl } from "react-intl";

export function useAllChecklistLabel() {
  const intl = useIntl();
  return intl.formatMessage({
    defaultMessage: "All Checklists",
    description: "WorkspaceRoutinesOccasion headerBackTitle",
  });
}
